import CryptoJS from 'crypto-js'
import utils from '@/utils/utils'

let Base64 = require('js-base64').Base64

// 十六位十六进制数作为密钥
const defaultKey = CryptoJS.enc.Utf8.parse('451fd155751978ae')
// 十六位十六进制数作为密钥偏移量
const iv = CryptoJS.enc.Utf8.parse('03298f926df0e295')
const secret = {
}
/** 加密文本 */
secret.encryptionText = function (word) {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, defaultKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString().toUpperCase()
}

/** 解密文本 */
secret.decryptText = function (word) {
  if (utils.isNotEmpty(word)) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
    let decrypt = CryptoJS.AES.decrypt(srcs, defaultKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
  } else {
    return ''
  }
}

/** 解密资源文本内容  */
secret.decryptResourceContent = function (word) {
  if (utils.isNotEmpty(word)) {
    return Base64.decode(word)
  } else {
    return ''
  }
}

/**
 * AES加密 ：字符串 key iv  返回base64 
 */
secret.Encrypt = function (word, keyStr, ivStr) {
  let key = ''
  let iv = ''

  if (keyStr) {
    key = CryptoJS.enc.Utf8.parse(keyStr);
    iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  })
 // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
/**
 * AES 解密 ：字符串 key iv  返回base64  
 */
secret.Decrypt = function(word, keyStr, ivStr) {

  // String s = new String(Base64.getDecoder().decode("PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNv"));

  let base64 = CryptoJS.enc.Base64.parse(word);
  let src = CryptoJS.enc.Base64.stringify(base64);

  var decrypt = CryptoJS.AES.decrypt(src, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

/** 曹文妍添加 加密 accessToke */
/** 加密文本 */
secret.encrypts= function (word, keyStr, ivStr) {
  let key = key
  let iv = iv

  if (keyStr) {
      key = CryptoJS.enc.Utf8.parse(keyStr);
      iv = CryptoJS.enc.Utf8.parse(ivStr);
  }

  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
  });
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

export default secret



// WEBPACK FOOTER //
// ./src/utils/secret.js